"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleAnalyticsSendOptions = void 0;
const GoogleAnalyticsSendOptions = exports.GoogleAnalyticsSendOptions = {
  DIRECTLY: 'Send events directly to GA.',
  DATA_LAYER: 'Send events to data layer.'
};